module.exports = __WEBPACK_EXTERNAL_MODULE_85__;


//////////////////
// WEBPACK FOOTER
// external "weaPortalPublic"
// module id = 85
// module chunks = 0